// @ts-ignore
import defaultLogo from "../../../images/titleLogixLogo.png";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa6";
import { useUtilDataQuery, useMarkListAsReadNotificationMutation, useMarkListAsUnReadNotificationMutation } from "../../../features/profile/profileApi";
import { tgxApi } from "../../../app/tgxApi";
import { useDispatch } from "react-redux";
import { FaSearch, FaSync, FaTimes } from "react-icons/fa";
import SearchOrderModal from "../modal/SearchOrderModal";
import { getHumanReadableDateDifference, getNotificationIcon, notificationSorting } from "../../../helpers/utils/Utils";
import { useBaseUrlQuery } from "../../../features/login/loginPageApi";
import moment from "moment";
import { useLazySearchOrdersQuery } from "../../../features/order/ordersApi";

const Header: React.FC = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showOrderSearchModal, setShowOrderSearchModal] = useState(false);
    const [orderNumber, setOrderNumber] = useState<string>("");
    const [showNotification, setShowNotification] = useState(false);
    const { data: utilData } = useUtilDataQuery("");
    const dispatch = useDispatch();
    const [triggerGlobalSearchProducts] = useLazySearchOrdersQuery();
    const [tenant, setTenant] = useState("");
    const [username, setUsername] = useState("");

    const baseUrl = `${window.location.host}`;
    const tenantData = useBaseUrlQuery(baseUrl);
    const [tenantLogoUrl, setTenantLogoUrl] = useState(null);
    const [markListAsUnReadNotifications] = useMarkListAsUnReadNotificationMutation();
    const [markListAsReadNotifications] = useMarkListAsReadNotificationMutation();
    useEffect(() => {
        if (utilData?.userName) {
            setUsername(utilData.userName);
        }
        if (utilData?.tenant) {
            setTenant(utilData.tenant);
        }
    }, [utilData]);

    useEffect(() => {
        if (tenantData?.data) {
            const tenantName = tenantData.data.name;
            if(tenantData.data.logoImageId){
                // @ts-ignore
                setTenantLogoUrl(process.env.REACT_APP_BASE_URL + `/ajax/image/bytes/${tenantData.data.logoImageId}`);
            }
        }
    }, [tenantData]);


    const handleSearchOrder = async (e: React.FormEvent) => {
        e.preventDefault();

        if (orderNumber) {
            setShowLoader(true);
            try {
                const response = await triggerGlobalSearchProducts({
                    customerOrderNumber: orderNumber,
                    sort: "creationDate", sortOrder: "DESCENDING", pageNumber: 0, pageSize: 8
                }).unwrap();
                if (response.data?.length === 1) {
                    window.location.href = `/orders/${response.data[0].id}`;
                    setShowOrderSearchModal(false);
                } else {
                    setShowLoader(false);
                    setShowOrderSearchModal(true);
                }
            } catch (error) {
                console.error("Error fetching order:", error);
            }
        }
    };
    const markListAsUnRead = (e: any) => {
        e.preventDefault();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.replaceAll("/", "&");
        markListAsUnReadNotifications(timeZone);
    }

    const markAsRead = (curNotification: any) => {
        if (curNotification.read === false) {
            markListAsReadNotifications(curNotification.id)
            window.open(curNotification.url, '_blank', 'noopener,noreferrer');
        } else {
            if (curNotification.url != null && curNotification.url !== '') {
                window.open(curNotification.url, '_blank', 'noopener,noreferrer');
            }
        }
    }
    const globalOrderSearchBar = () => {
        return <div className="relative mr-2">
            <input
                type="text"
                className="bg-surface-5 placeholder:text-[#696c6e] pr-12 text-[#696c6e] border border-gray-300  px-2 py-[2px] w-72  rounded-[2px]"
                placeholder="Search by Order Number..."
                name="search"
                value={orderNumber}
                onChange={(e) => setOrderNumber(e.target.value)}
                onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                        void handleSearchOrder(e);
                    }
                }}
            />


            {showLoader && <FaSync
                className="absolute top-[6px] fa-spin text-surface-0 right-4"
                onClick={() => setOrderNumber("")}
            />}

            {orderNumber && !showLoader &&
                <FaTimes
                    className="absolute top-[6px] right-10 cursor-pointer"
                    onClick={() => setOrderNumber("")}
                />
            }


            {!showLoader &&
                <FaSearch className="absolute top-[6px] right-3 cursor-pointer hover:text-surface-0"
                    onClick={(e) => {
                        void handleSearchOrder(e);
                    }} />
            }
        </div>;
    }
    const NotificationTray = () => {
        const dropdownRef = useRef<HTMLDivElement>(null);

        useEffect(() => {
            function handleClickOutside(event: MouseEvent) {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                    setShowNotification(false);
                }
            }

            if (showNotification) {
                document.addEventListener("mousedown", handleClickOutside);
            }

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [showNotification]);

        return (
            <div className="relative m-0" ref={dropdownRef}>
                <button
                    className="text-text-0 dropdown-toggle flex items-center notification_outer pt-2 lg:pt-0 sm:pt-2"
                    type="button"
                    id="dropdownMenu2"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => setShowNotification(!showNotification)}
                >
                    <i title="View notifications" className="fa fa-envelope text-3xl hover:text-surface-3" />
                    <i className="fa fa-caret-down mt-2 p-1 text-xs" aria-hidden="true" />
                    {utilData?.notifications?.filter((n: any) => !n.read).length > 0 &&
                        <span className="bg-[#00adf5] text-text-0 inline-block h-5 w-5 leading-[19px] text-center rounded-full absolute top-0 right-3">
                            {utilData?.notifications?.filter((n: any) => !n.read).length}
                        </span>
                    }
                </button>

                {showNotification && (
                    <div className="bg-text-0 shadow-lg border border-surface-5 rounded-lg absolute top-10 right-0 w-[500px] notification_wrapper">
                        <div className="flex justify-between items-center px-4 py-2">
                            <span className="text-xl font-medium">Notifications</span>
                            <i
                                className={`fa-solid fa-envelope-open text-xl cursor-pointer ${utilData?.notifications?.some((n: { read: any }) => !n.read)
                                    ? "text-highlight-0"
                                    : "text-[gray]"
                                    }`}
                                title="Mark all as read"
                                onClick={
                                    utilData?.notifications?.some((n: { read: any }) => !n.read)
                                        ? markListAsUnRead
                                        : undefined
                                }
                            />
                        </div>

                        <ul className="max-h-[632px] overflow-y-auto">
                            {utilData?.notifications?.length > 0 ? (
                                notificationSorting(utilData?.notifications, ["read", "creationDate"], ["asc", "desc"]).map((notification: any) => (
                                    <li
                                        key={notification.id}
                                        className={`hover:bg-text-1 flex p-3 items-center border-b-[1px] border-text-0 cursor-pointer ${notification.read ? "bg-text-1" : "bg-text-0"
                                            }`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            markAsRead(notification);
                                        }}
                                    >
                                        <i className={`${getNotificationIcon(notification.type)} text-md mt-1 ${notification.read ? "" : "text-[#01adf5]"
                                            }`} />
                                        <div className="ml-3 flex-1">
                                            <a
                                                className={`${notification.url ? "text-highlight-4" : "text-surface-[5]"
                                                    }`}
                                                href={notification.url || "#"}
                                            >
                                                {notification.description}
                                            </a>
                                            <p className="text-xs text-gray-500 m-0 text-text-2">
                                                {getHumanReadableDateDifference(moment(notification.creationDate))}
                                            </p>
                                        </div>
                                    </li>
                                ))
                            ) : (
                                <li className="p-4 text-center text-gray-500">No notifications to display</li>
                            )}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    const profileButton = () => {
        return <div className="pt-2 lg:pt-0 sm:pt-2">
            <button
                onClick={() => navigate("/profile")}
                className="text-text-0"
                title='View user profile'>
                <span className="text-text-0  hover:text-highlight-7">
                    <i className="fa fa-cog mr-2 text-md" />
                </span>
            </button>
        </div>
    }
    const logoutButton = () => {
        return <div className="pt-2 lg:pt-0 sm:pt-2 flex items-center text-text-0">
            {utilData?.userName}
            <button
                className="items-center ml-3"
                onClick={() => {
                    localStorage.clear();
                    dispatch(tgxApi.util.resetApiState());
                    navigate("/login")
                }}>

                <i className="fas fa-sign-out-alt text-text-0 hover:text-highlight-7 text-lg"
                    title="Log out" />
            </button>
        </div>;
    }
    return (
        <>
            <header
                className=" sm:block py-1.5 pr-5 pl-4 lg:flex md:block z-50 items-center fixed w-full header bg-surface-0 px-2 border-b-2 ">
                <div className="sm:flex justify-between lg:block md:flex flex items-center">
                    <Link to="/home" className="flex items-center space-x-2">
                        <img
                            className={`h-10 object-contain ${tenantLogoUrl === defaultLogo ? "blur-sm" : ""}`}
                            src={tenantLogoUrl || defaultLogo}
                            alt="Company Logo"
                            width={207}
                        />
                    </Link>
                    <FaBars className="text-text-0 lg:hidden sm:block md:block" onClick={() => setShow(!show)}/>
                </div>
                <div
                    className={`navbar-collapse py-3 sm:py-3 lg:py-0 ms-auto lg:block  ${show ? "block" : "hidden"
                        }`}
                >
                    <div className="right_nav items-center  sm:block md:block lg:flex gap-2">
                        {globalOrderSearchBar()}
                        {NotificationTray()}
                        {profileButton()}
                        {logoutButton()}
                    </div>
                </div>
            </header>

            {showOrderSearchModal && <SearchOrderModal
                show={showOrderSearchModal}
                setShow={setShowOrderSearchModal}
                orderNumber={orderNumber}
                setOrderNumber={setOrderNumber}
            />
            }
        </>
    );
};

export default Header;
